export function GenerateRandomKey() {
  return Math.random().toString(36).slice(2);
}

export function GenerateRandomNumber() {
  return Math.random();
}

export default GenerateRandomKey;
